import classNames from 'classnames';
import type { FlexProps, FullWidthProps, SharedComponentProps } from '../types';
import * as styles from './index.css';

export type CardProps = SharedComponentProps<'div'> &
    FullWidthProps &
    FlexProps & {
        pt?: keyof typeof styles.paddingTopVariants;
        pr?: keyof typeof styles.paddingRightVariants;
        pb?: keyof typeof styles.paddingBottomVariants;
        pl?: keyof typeof styles.paddingLeftVariants;
        withBorder?: boolean;
        boxShadow?: styles.BoxShadow;
    };

export function Card({
    pt = '6',
    pr = '6',
    pb = '6',
    pl = '6',
    withBorder = false,
    fullWidth = false,
    boxShadow = 'type1',
    className,
    children,
    ...props
}: CardProps) {
    return (
        <div
            className={classNames(
                styles.card,
                styles.paddingTopVariants[pt],
                styles.paddingRightVariants[pr],
                styles.paddingBottomVariants[pb],
                styles.paddingLeftVariants[pl],
                {
                    [styles.fullWidth]: fullWidth,
                    [styles.border]: withBorder,
                    [styles.shadowVariants[boxShadow]]: boxShadow,
                },
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
}
